import styled, { keyframes } from "styled-components";
import { GREEN } from "../../constants/theme";

const lineGrow = keyframes`
  0% {
    transform: scaleX(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scaleX(1);
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Section = styled.section`
  position: relative;
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  text-align: center;
  @media (min-width: 768px) {
    padding: 32px 16px;
  }
`;
export const HeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
`;
export const GradientLine = styled.span`
  display: block;
  font-size: 3.5rem;
  font-weight: 800;
  white-space: nowrap;
  background-image: linear-gradient(to right, ${GREEN}, ${GREEN});
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  line-height: 1.5;
`;
export const HeroLine = styled.span`
  display: block;
  font-size: 3rem;
  font-weight: 800;
  white-space: nowrap;
  color: #0f172a;
`;
export const Lead = styled.div`
  position: relative;
  width: 60%;
  color: #475569;
  font-size: 1.125rem;
  line-height: 1.5;
`;
export const PrimaryBtn = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  color: #fff;
  background: ${GREEN};
`;
export const HeroUnderline = styled.div`
  position: relative;
  height: 4px;
  width: 100%;
  max-width: 768px;
  background: ${GREEN};
  transform-origin: left;
  animation: ${lineGrow} 1.2s ease-out forwards;
`;
